<template>
  <el-card shadow="never" class="status_card sbu">
    <div slot="header" v-if="title">
      <h4>{{ title }}</h4>
    </div>
    <div>
      <el-form :label-width="labelWidth" :label-position="labelPosition">
        <template v-for="(itmes, index) in checkboxArr">
          <el-form-item :label="itmes.title" :key="index" class="item">
            <el-checkbox-group
              v-model="itmes.checkbox"
              @change="change($event, index)"
            >
              <template v-for="(list, ind) in itmes.list">
                <el-checkbox :label="list.value">{{ list.name }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
        </template>
      </el-form>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    labelWidth: {
      type: String,
      default: "80px",
    },
    labelPosition: {
      type: String,
      default: "left",
    },
    title: String,
    dataArr: Array,
    // dataArr: [
    //   {
    //     title: "",
    //     checkbox: [],
    //     list: [
    //       {
    //         name: "Open", 、、顯示名稱
    //         apiName: "open", //api 字段名
    //         value: "open1", //選中值
    //       },
    //       {
    //         name: "Closed",
    //         apiName: "closedpen",
    //         value: "closedpen",
    //       },
    //       {
    //         name: "Cancel",
    //         apiName: "cancel",
    //         value: "cancel",
    //       },
    //     ],
    //   },
    // ],
  },
  data() {
    return {
      checkboxArr: [],
      dataObj: {},
    };
  },
  methods: {
    change(e, index) {
      if (e.length > 1) {
        this.checkboxArr[index].checkbox = [e[e.length - 1]];
      }
      let data = {};
      for (let i = 0; i < this.checkboxArr.length; i++) {
        for (let t = 0; t < this.checkboxArr[i].list.length; t++) {
          if (
            this.checkboxArr[i].list[t].value ==
            this.checkboxArr[index].checkbox[0]
          ) {
            let name = this.checkboxArr[index].list[0].apiName;
            data[name] = this.checkboxArr[index].checkbox[0];
          }
        }
      }
      this.dataObj = { ...this.dataObj, ...data };
      if (e.length == 0) {
        delete this.dataObj[this.checkboxArr[index].list[0].apiName];
      }
      this.$emit("change", this.dataObj);
    },
  },
  mounted() {
    this.checkboxArr = this.dataArr;
  },
};
</script>
<style >
.status_card .el-form-item__label {
  font-weight: 600;
}
</style>
<style scoped>
.item {
  margin-bottom: 0;
}
.status_card {
  height: 100%;
}
</style>